<template>
  <KitchenPage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import KitchenPage from '@/components/Kitchen.vue'

export default {
  name: 'Kitchen',
  components: {
    KitchenPage
  }
}
</script>
